





































































import Vue from 'vue';
import { ISenderDomain, IState, IEmailFlow } from '@/store/types';
import OrgService from '@/api/org.service';
import { SYNC_ORG } from '@/store/action-types';

export default Vue.extend({
  name: 'EmailBasedFlowSettings',
  components: {},
  data() {
    return {
      loading: true,
      emailFlow: {
        enabled: false /* not used yet */,
        from: '',
        senderName: '',
        replyTo: '',
        subject: '',
      } as IEmailFlow,
    };
  },
  async created() {
    await this.$store.dispatch(SYNC_ORG);
    const state = this.$store.state as IState;
    const emailFlow = state.org?.emailFlow;
    if (emailFlow) {
      this.emailFlow.enabled = emailFlow.enabled;
      this.emailFlow.from = emailFlow.from;
      this.emailFlow.senderName = emailFlow.senderName;
      this.emailFlow.replyTo = emailFlow.replyTo;
      this.emailFlow.subject = emailFlow.subject;
    }
    this.loading = false;
  },
  computed: {
    senderDomains(): string[] {
      const domains: ISenderDomain[] = this.$store.state.org.dunning.senderDomains as [ISenderDomain];
      if (domains.length === 0) {
        return [];
      }
      const domainStrings: string[] = domains.filter((domain) => domain.dkimVerified && domain.returnPathVerified).map((domain) => domain.url);
      return domainStrings;
    },
    hasSenderDomains(): boolean {
      return this.senderDomains.length > 0;
    },
    firstSenderDomain(): string {
      return this.senderDomains[0];
    },
    placeholderDomain(): string {
      return this.hasSenderDomains ? this.firstSenderDomain : 'domain.com';
    },
    fromDomain(): string {
      const { from } = this.emailFlow;
      if (!from) return '';
      const fromDomain = from.split('@');
      if (fromDomain.length < 2) return '';
      return fromDomain[1];
    },
    verifiedFrom(): boolean {
      if (this.fromDomain === '') return true;
      return this.senderDomains.includes(this.fromDomain);
    },
    validArgs(): boolean {
      return !!this.emailFlow.senderName && !!this.emailFlow.from && !!this.fromDomain;
    },
    changesMade(): boolean {
      // compare local customAttributes to state
      const state = this.$store.state as IState;
      const emailFlow = state.org?.emailFlow;
      if (!emailFlow) {
        return true; // setting up for the first time
      }
      if (JSON.stringify(emailFlow) !== JSON.stringify(this.emailFlow)) {
        return true; // changes were made
      }
      return false;
    },
    orgName(): string {
      return this.$store.state.org.name;
    },
  },
  methods: {
    async save() {
      this.loading = true;
      try {
        const emailFlow = this.emailFlow;
        await OrgService.update(this.$store.state.org._id, { emailFlow });
        await this.$store.dispatch(SYNC_ORG);
      } catch (e) {
        console.error('Error saving org.emailFlow', e);
      } finally {
        this.loading = false;
      }
    },
  },
});
